import { Pagination } from "../Pagination";
import { PopUp } from "../PopUps/PopUp";
import { PatientComplementLogic } from "./PatientComplementLogic";
import { PatientComplementTable } from "./PatientComplementTable";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import Select from "react-select";
import { cs } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import { useAuth } from "../../contexts/AuthContext";
import { PermissionDenied } from "../PermissionDenied/PermissionDenied";

export const PatientComplement = (props) => {
  const { careType } = props;
  const { checkLicense } = useAuth();

  if (!checkLicense("complement")) {
    return <PermissionDenied />;
  }

  const {
    columns,
    data,
    loading,
    params,
    filter,
    error,
    options,
    togglePopup,
    getAllPatients,
    handleFilterChange,
    handleResetFilter,
    handleDateChange,
    handleParameterChange,
  } = PatientComplementLogic({ careType });

  // Register Czech locale for date picker
  registerLocale("cz", cs);

  // Transform options for react-select
  const parameterOptions = options.map((option) => ({
    value: option.id,
    label: option.name,
  }));

  // Get selected parameters for multi-select
  const selectedParameters = parameterOptions.filter((option) =>
    filter.complement_parameter_definition__in.includes(option.value)
  );

  return (
    <div className="requisitions">
      <div className="max-w-auto">
        <div className="myContent">
          {loading ? (
            <h2>Načítání...</h2>
          ) : (
            <>
              {error.error && (
                <PopUp toggle={togglePopup} message={error.message} />
              )}
              <div className="container-fluid">
                <div className="col-xl-12 col-lg-12">
                  <div className="row">
                    <div className="col-md-12 col-xl-8">
                      <div className="input-group">
                        <label className="strong">Laboratorní parametr:</label>
                        <Select
                          isMulti
                          value={selectedParameters}
                          onChange={handleParameterChange}
                          options={parameterOptions}
                          placeholder="Vyberte parametry..."
                          className="react-select-container"
                          classNamePrefix="react-select"
                          isClearable
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              borderRadius: 0,
                              minHeight: 42,
                            }),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input-group">
                        <label className="strong">Datum výsledkú od:</label>
                        <div className="date-picker-container">
                          <ReactDatePicker
                            selected={
                              filter.complement_sampling__made_at__gte
                                ? new Date(
                                    filter.complement_sampling__made_at__gte
                                  )
                                : null
                            }
                            onChange={(date) =>
                              handleDateChange(
                                date,
                                "complement_sampling__made_at__gte"
                              )
                            }
                            dateFormat="dd.MM.yyyy"
                            calendarStartDay={1}
                            className="inp-datepicker"
                            placeholderText="dd.mm.rrrr"
                            locale="cz"
                            isClearable
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="input-group">
                        <label className="strong">Datum výsledkú do:</label>
                        <div className="date-picker-container">
                          <ReactDatePicker
                            selected={
                              filter.complement_sampling__made_at__lte
                                ? new Date(
                                    filter.complement_sampling__made_at__lte
                                  )
                                : null
                            }
                            onChange={(date) =>
                              handleDateChange(
                                date,
                                "complement_sampling__made_at__lte"
                              )
                            }
                            dateFormat="dd.MM.yyyy"
                            calendarStartDay={1}
                            className="inp-datepicker"
                            placeholderText="dd.mm.rrrr"
                            locale="cz"
                            isClearable
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row-button" style={{ paddingBottom: 10 }}>
                <button
                  type="submit"
                  className="button"
                  onClick={() => getAllPatients()}
                >
                  Vyhledat
                </button>
              </div>
              <PatientComplementTable
                data={data.data}
                columns={columns[careType]}
                filter={filter}
                handleFilterChange={handleFilterChange}
                handleDateChange={handleDateChange}
                handleResetFilter={handleResetFilter}
                onSubmit={getAllPatients}
                careType={careType}
              />

              <Pagination
                onSubmit={getAllPatients}
                pagination={data.pagination}
                paramsState={params}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
